import React from 'react';
import { translate } from 'react-multi-lang';
import { Table, Input, Button, Space, Row, Col } from 'antd';
import { SearchOutlined, LockFilled, UnlockFilled } from '@ant-design/icons';
import { AllHtmlEntities } from 'html-entities';

import ContainerPagina from '../../../components/ContainerPagina';
import TitolPagina from '../../../components/TitolPagina';
import LlistaEditable from '../../../components/LlistaEditable';
import Edit from '../../../components/Formularis/perfils/admin/Professors';
import { Api, InitDades } from '../../../helpers';

const { Column } = Table;
const entities = new AllHtmlEntities();

class Professors extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      searchText: '',
      searchedColumn: '',
    };
  }

  buscarDades = async () => {
    const fam = await Api.get('/professors');
    if(fam.result.success===1){
      console.log('Llista Professors: ',fam.data.professors)
      return fam.data.professors;
    }
  }
  marcarEliminat = async (id) => {
    const fam = await Api.myFetch('/professors/'+id, 'DELETE');
    if(fam.result.success===1){

    }
  }

  getColumnSearchProps = (dataIndex, nom) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`${this.props.t('generic.cercar')} ${nom}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            {this.props.t('generic.cercar')}
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      //record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
      record[dataIndex] ? this.arreglarTxt4Search(entities.decode(record[dataIndex].toString())).includes(this.arreglarTxt4Search(value)) : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text => (entities.decode(text)),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  arreglarTxt4Search = text =>{
      // Poso en minuscules, normalitzo caracters treure accents i ñ , elimina els caracters diacrítics raros d'un text (ES6)
        return text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
  }
render(){


  const filtreBloqueig =[
    {text: <LockFilled style={{color: 'red'}}/>, value: 1},
    {text: <UnlockFilled style={{color: 'green'}}/>, value: 0}
  ];

  const columns = [
  {
    title:"Id",
    key:"id",
    sorter: (a, b) =>  a.id - b.id,
    render: (text,record) => (<span>{record.id}</span>)
  },{
    title: this.props.t('professors.nom'),
    key:"nom",
    dataIndex: 'nom',
    render: (text,record) =>(entities.decode(record.nom)),
    sorter: (a, b) => { return entities.decode(a.nom).localeCompare(entities.decode(b.nom))},
    ...this.getColumnSearchProps('nom',this.props.t('professors.nom'))
  },{
    title: this.props.t('professors.cognom1'),
    key: "cognom1",
    dataIndex: 'cognom1',
    render: (text,record) =>(entities.decode(record.cognom1)),
    sorter: (a, b) => { return entities.decode(a.cognom1).localeCompare(entities.decode(b.cognom1))},
    ...this.getColumnSearchProps('cognom1',this.props.t('professors.cognom1'))
  },{
    title:this.props.t('professors.cognom2'),
    key:"cognom2",
    dataIndex: 'cognom2',
    render:(text,record) =>(entities.decode(record.cognom2)),
    sorter: (a, b) => { return entities.decode(a.cognom2).localeCompare(entities.decode(b.cognom2))},
    ...this.getColumnSearchProps('cognom2',this.props.t('professors.cognom2'))
  },{
    title:this.props.t('professors.email'),
    key:"email",
    dataIndex:'email',
    render:(text,record) => (record.professors ? record.professors : ''),
    sorter: (a, b) => { return entities.decode(a.email).localeCompare(entities.decode(b.email))},
    ...this.getColumnSearchProps('email',this.props.t('professors.email'))
  },{
    title:this.props.t('professors.tel1'),
    key:"tel1",
    responsive:['md'],
    render:(text,record) => (record.tel1 ? record.tel1 : '')
  },{
    title:this.props.t('users.bloqueado'),
    key:"tel1",
    filters: filtreBloqueig,
    defaultFilteredValue: ['0'],
    onFilter: (value, record) => record.app_locked === value,
    render:(text,record) => (record.app_locked ? <LockFilled style={{color: 'red'}}/> : <UnlockFilled style={{color: 'green'}}/>)
  }];


  return(
    <ContainerPagina xl={24}>
      <TitolPagina txt={this.props.t('menu.Professors')}/>
      <div style={{marginTop:'1rem', marginLeft:'3rem'}}>
        <LlistaEditable
          txt_creats={this.props.t('professors.creados')}
          txt_nou={this.props.t('professors.nuevo')}
          buscarDades={this.buscarDades}
          edit={Edit}
          delete={this.marcarEliminat}
          itemBuit={InitDades.pare()}
          columns={columns}
        />
      </div>
    </ContainerPagina>
  );
}
}

export default translate(Professors);
